<span> {{ 'UI.PoweredBy' | translate }}</span>
<a href="https://www.bbv.ch" class="ml-2">
  <app-shared-icon name="logoBBV" width="50px" height="30px"></app-shared-icon>
</a>
